import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";
  import type { OptionalUpgrade } from "@/types/OptionalUpgradeInterface";
  import { formatPrice as formatPriceHelper } from "@/helpers/transformation/price";

  const PROMOTIONS_SECTION_TITLE = "PROMOTIONS / OPTIONAL UPGRADES";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'BuilderEstimatorSummaryItemWithoutImage',
  props: {
    title: {},
    value: {},
    price: {},
    isMobile: { type: Boolean }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

  const props = __props;

  const isUpgradeSection = computed(
    () =>
      props.title === PROMOTIONS_SECTION_TITLE &&
      Array.isArray(props.value) &&
      props.value !== null
  );

  const formatPrice = (price: number | null): string => {
    if (price === null || price === undefined) return "";

    return price === 0 ? "Included" : formatPriceHelper(price, true);
  };

const __returned__ = { PROMOTIONS_SECTION_TITLE, props, isUpgradeSection, formatPrice, computed, get formatPriceHelper() { return formatPriceHelper } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})